
try {

var vk_cache_admin_loaded;

function vk_cache_admin() {
    if (!vk_cache_admin_loaded) {
        vk_cache_admin_loaded = 1;

        $async(["/℅/cache-admin.js", "/℅/cache-admin.css"]);

        return 'Cache admin wordt geladen... (zie rechterzijde van beeld voor cache-icoon)';
    } else {
        return 'Cache admin is reeds geladen';
    }
}
window.$vk = vk_cache_admin;
/*
function styletools() {
    return fetch('/styletools/', {
        method: 'post',
        headers: {
            'Accept': 'application/json, text/plain, * /*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'style.tools': 'cms',
            'config': window.o10nConfig
        }),
        credentials: 'include'
    }).then(function(res) {
        return res.json().then(function(json) {
            eval(json.js);
            window.load_styletools = load_styletools;
            window.StyleToolsCMSConnect = StyleToolsCMSConnect;

            StyleToolsCMSConnect.on('save', function(result) {
                if (result.sheet) {
                    localStorage.clear();
                    var myHeaders = new Headers();
                    myHeaders.append('pragma', 'no-cache');
                    myHeaders.append('cache-control', 'no-cache');

                    var myInit = {
                        method: 'GET',
                        headers: myHeaders,
                        cache: "reload"
                    };

                    var myRequest = new Request(result.sheet);

                    return fetch(myRequest, myInit);
                }
                console.log('saved', result.sheet);
            });

            StyleToolsCMSConnect.on('save_critical', function(result) {
                console.log('saved', result);
            });

            console.log('📐 Style.Tools loaded');
            return true;
        });
    }).catch(console.error);
}
*/

var cacheAdmin = sessionStorage.getItem('vk-cache-admin');
if (cacheAdmin) {
    vk_cache_admin();
}

} catch(e){_st_catch(e)}
